export const rolePermissionQueryKeys = {
  all: () => "role-permission"
};
